<template>
  <draggable
    v-bind="dragOptions"
    :list="list"
    :value="value"
    draggable=".gp-draggable"
    @input="emitter"
    @start="dragStart"
    @end="dragEnd"
    @change="cleanup"
  >
    <div v-for="cat in realValue" :key="cat.id" class="gp-draggable">
      <div
        class="w-full h-12 p-3 mb-2 flex items-center rounded-md"
        style="background-color: var(--brand-secondary-light)"
      >
        <div class="w-2 mr-2">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="8"
            height="16"
            class="cursor-move"
          >
            <path
              fill="#FFF"
              d="M1.333 13.333a1.333 1.333 0 110 2.667 1.333 1.333 0 010-2.667zm5.334 0a1.333 1.333 0 110 2.667 1.333 1.333 0 010-2.667zM1.333 6.667a1.333 1.333 0 110 2.666 1.333 1.333 0 010-2.666zm5.334 0a1.333 1.333 0 110 2.666 1.333 1.333 0 010-2.666zM1.333 0a1.333 1.333 0 110 2.667 1.333 1.333 0 010-2.667zm5.334 0a1.333 1.333 0 110 2.667 1.333 1.333 0 010-2.667z"
            ></path>
          </svg>
        </div>
        <div class="flex-1">{{ cat.name }}</div>
        <div class="text-sm">
          <dropdown-button>
            <div
              class="flex justify-end cursor-pointer items-center"
              slot="link"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="none"
                viewBox="0 0 24 24"
              >
                <circle cx="4" cy="12" r="2" fill="var(--brand-secondary-lightest)" />
                <circle cx="12" cy="12" r="2" fill="var(--brand-secondary-lightest)" />
                <circle cx="20" cy="12" r="2" fill="var(--brand-secondary-lightest)" />
              </svg>
            </div>
            <div
              slot="dropdown"
              class="bg-white shadow rounded border border-grey-300 overflow-hidden cursor-pointer"
              style="width: 170px; position: relative; right: 140px"
            >
              <div
                class="no-underline block p-2 text-grey-darkest bg-white"
                @click="deleteCategory(cat.id)"
              >
                {{ $t('frontend_grooveblog_delete_from_navigation') }}
              </div>
            </div>
          </dropdown-button>
        </div>
      </div>
      <nav-category
        v-if="hasNesting"
        :nest-level="nestLevel + 1"
        :max-nesting="maxNesting"
        class="ml-4"
        :list="cat.children"
      />
    </div>
  </draggable>
</template>
<script>
import draggable from 'vuedraggable';

export default {
  name: 'NavCategory',
  components: {
    draggable,
  },
  props: {
    value: {
      required: false,
      type: Array,
      default: null,
    },
    list: {
      required: false,
      type: Array,
      default: null,
    },
    maxNesting: {
      required: false,
      type: Number,
    },
    nestLevel: {
      required: false,
      type: Number,
      default: 0,
    },
    callMethod: '',
  },
  data() {
    return {
      dragging: false,
    };
  },
  computed: {
    dragOptions() {
      return {
        swapThreshold: 0.75,
        animation: 75,
        group: 'listitem',
        disabled: false,
        ghostClass: 'ghost',
      };
    },
    realValue() {
      return this.value ? this.value : this.list;
    },
    hasNesting() {
      if (typeof this.maxNesting === 'undefined') return true;
      if (this.nestLevel === this.maxNesting) return false;
      return true;
    },
  },
  methods: {
    dragStart() {
      this.dragging = true;
    },
    dragEnd() {
      this.dragging = false;
      this.cleanup();
      this.$root.$emit('orderChange');
    },
    cleanup() {
      document.querySelectorAll('.gp-draggable').forEach((element) => {
        element.removeAttribute('style');
      });
    },
    emitter(value) {
      this.$emit('input', value);
    },
    deleteCategory(id) {
      this.$root.$emit('deleteCategory', { id: id });
    },
  },
};
</script>
